<template>
	<div class="live-schedule1" :class="[showChooseTime || showQrcode || showPicker ? 'max-page-height' : '']">
		<van-empty description="内容正在完善中..." v-if="isempty" />
		<div v-else>
			<!-- <div class="timeTabs-wrap" v-if="scheduleDate.length!=0">
				<div class="timeTabs" v-if="color">
					<div class="tab-item" v-for="(item,index) in scheduleDate" :key="index" @click="switchDate(item)" :class="item==active?'active':''" :style="{background:(item==active?color:'')}">
						{{item}}
					</div>
				</div>
				<div class="timeTabs" v-else>
					<div class="tab-item" v-for="(item,index) in scheduleDate" :key="index" @click="switchDate(item)" :class="item==active?'active':''">
						{{item}}
					</div>
				</div>			
			</div> -->
			<div class="content" ref="view">
				<div v-for="(item, suffix) in scheduleList" :key="suffix">
					<div v-for="(value, index) in item" :key="index">
						<div class="scheduleHead">
							<div class="name-time">
								<div class="left-flex" style="width:100%;" :id="'time_' + index">
									<h3 v-if="value.name">
										<span v-if="path == '/vascularNews/expert/detail'">{{ suffix }}</span>
										{{ value.name }}
									</h3>
									<div class="logo" v-if="value.image">
										<img :src="value.image" alt="" v-if="value.image" />
									</div>
									<div class="expert" v-if="meeting_id != 616 && meeting_id != 618">
										<span class="time2">{{ value.start_at_s + ' - ' + value.end_at_s }}</span>
									</div>
								</div>
							</div>
							<div class="attendee">
								<!-- <div class="expert">
									<span>{{value.start_at+' - '+ value.end_at}}</span>
								</div> -->
								<div class="chairman expert" v-if="value.chairman_writers && value.chairman_writers.length > 0">
									<div class="flexRow-center">
										<span class="host_t">主&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;席:</span>
									</div>
									<div class="names">
										<p>
											<router-link
												:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: val.id } }"
												v-for="val in value.chairman_writers" :key="val.id">
												<p class="two-line"><img class="avatar" v-if="val.photo"
														:src="val.photo" alt="">{{ val.name }}<span
														v-if="val.company && meeting_id != 581">({{
															val.company }})</span></p>
											</router-link>
										</p>
									</div>
								</div>
								<div class="host expert" v-if="value.host_writers && value.host_writers.length > 0">
									<div class="flexRow-center">
										<span class="host_t">主持专家: </span>
									</div>
									<div class="names">
										<p>
											<router-link
												:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: val.id } }"
												v-for="val in value.host_writers" :key="val.id">
												<p class="two-line"><img class="avatar" v-if="val.photo"
														:src="val.photo" alt="">{{ val.name }}<span
														v-if="val.company && meeting_id != 581">({{
															val.company }})</span></p>
											</router-link>
										</p>
									</div>
								</div>
								<div class="discussors expert " v-if="value.discussor_writers && value.discussor_writers.length > 0">
									<div>
										<span class="text-top host_t">讨论专家:</span>
									</div>
									<div class="names">
										<p>
											<router-link
												:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: val.id } }"
												v-for="val in value.discussor_writers" :key="val.id">
												<p class="two-line"><img class="avatar" v-if="val.photo"
														:src="val.photo" alt="">{{ val.name }}<span
														v-if="val.company && meeting_id != 581">({{
															val.company }})</span></p>
											</router-link>

										</p>
									</div>
								</div>
								<div>
									<div class="discussors expert" v-for="(val) in value.titles" :key="val.id">
										<div class="flexRow-center">
											<span class="host_t">{{ val.title }}:</span>
										</div>
										<div class="names">
											<p>
												<router-link
													:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: item.id } }"
													v-for="item in val.writers" :key="item.id">
													<p class="two-line"><img class="avatar" v-if="item.photo"
															:src="item.photo" alt="">{{ item.name }}<span
															v-if="item.company && meeting_id != 581">({{
																item.company }})</span></p>
												</router-link>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="chapters">
							<!-- 新版日程 -->
							<div class="schedule-card" v-for="(val, ind) in value.details" :key="ind"
								:id="'chapter_' + val.id" :class="getScheduleCardClass(val)">
								<!-- 头部：时间 + 浏览量 -->
								<div class="card-header">
									<span class="time-tag">
										{{ formatDetailTime(val.start_at) }} - {{ formatDetailTime(val.end_at) }}</span>
									<!-- <div class="view-count" v-if="isWithinTimeRange(val.start_at, val.end_at) !== 1">
										<img src="@/assets/images/icon_see.png" />
										<span>{{ val.video_play_click_count || 0 }}</span>
									</div> -->
									<div v-if="val.is_preview == 0 && val.allow_preview == 1 && isWxBtn"
										class="nopreview">
										{{ val.preview_count ? val.preview_count + '人' : '' }}订阅
										<wx-open-subscribe template="0pevoMHKwlm1V7N2uUl6ucg-_swEPoKeg_JUmQrHVsE"
											@success="subscribeSuccess" @error="subscribeFail" :data-id="val.id"
											:data-preview="val.is_preview" :data-type="1" ref="subscribeBtn"
											class="launch-btn">
											<script type="text/wxtag-template" slot="style">
														<style>
														.subscribe-btn {
															position:absolute;
															top:0;
															left:0;
															opacity: 0;
															width:100%;
															height:100%;
														}
														</style>
													</script>
											<script type="text/wxtag-template">
														<button class="subscribe-btn"></button>
													</script>
										</wx-open-subscribe>
									</div>

									<p class="previewed" v-else-if="val.allow_preview == 1 && val.is_preview == 1"
										@click.stop="cancelSubscribe(val, 1)">
										已订阅
									</p>

									<p class="nopreview"
										v-else-if="safeMeetingInfo.extra_data.want_look_status == 1 && !val.is_want_look"
										@click.stop="wantLook(val)">
										{{ val.want_look_count ? val.want_look_count + '人' : '' }}想看
									</p>
									<p class="redbtn"
										v-else-if="safeMeetingInfo.extra_data.want_look_status == 1 && val.is_want_look"
										@click.stop="wantLook(val)">
										已想看
									</p>


								</div>

								<!-- 标题 -->
								<p class="card-title"
									:class="{ 'is-live': isWithinTimeRange(val.start_at, val.end_at) === 2 }">
									{{ val.name }}
								</p>
								<!-- 讲者信息（保留现有 writers 循环） -->
								<div class="card-speaker">
									<router-link
										:to="{ path: '/vascularNews/expert/detail', query: { meeting_id: meeting_id, writer_id: i.id } }"
										v-for="i in val.writers" :key="i.id">
										<p class="name two-line" style="">
											<img class="avatar" v-if="i.photo" :src="i.photo" alt="">{{ i.name }}<span
												v-if="i.company && meeting_id != 581">({{
													i.company
												}})</span>
										</p>
									</router-link>
								</div>


								<!-- 模式一：直播已结束 + 有录播 -->
								<template
									v-if="isWithinTimeRange(val.start_at, val.end_at) === 3 && val.recordid && safeMeetingInfo.lookback_status">
									<div class="card-cover" @click="playRecorded(index, ind, (value.session && value.session.id), val)"
										v-if="val.screen_short">
										<img :src="val.screen_short" />
										<div class="card-cover-shadow"></div>
										<div class="play-overlay">
											<van-icon
												name="https://medwiki-cloud.oss-cn-hangzhou.aliyuncs.com/uploads/images/07/cbd79d2804f23274019f9cf2aae68d.png" />
										</div>
									</div>
									<div class="card-actions">
										<button class="btn-playback"
											@click="playRecorded(index, ind, (value.session && value.session.id), val)">
											<van-icon size="20"
												name="https://medwiki-cloud.oss-cn-hangzhou.aliyuncs.com/uploads/images/55/4a24442424b587b4a6fd603983fd4f.png" />
											点击播放录播
										</button>
										<button class="btn-ai"
											v-if="safeMeetingInfo.extra_data.schedule_video_ai_status == 1"
											@click="openAISummary(val)">摘要</button>
									</div>
								</template>


								<!-- 模式二：直播中 -->
								<template v-else-if="isWithinTimeRange(val.start_at, val.end_at) === 2">
									<div class="card-live-status">
										<div class="live-indicator">
											<img
												src="https://medwiki-cloud.oss-cn-hangzhou.aliyuncs.com/uploads/images/5b/a769d0accff8f548e39da42de4244f.png" />
											直播中
										</div>
										<button class="btn-live-play" @click="playLive()">
											<van-icon size="20" name="play-circle-o" /> 播放
										</button>
									</div>

								</template>

								<!-- 模式三：未开始 -->
								<template v-else-if="isWithinTimeRange(val.start_at, val.end_at) === 1">
									<div class="card-not-started">
										<van-icon name="clock-o" /> 未开始
									</div>
									<!-- 保留订阅/想看按钮 -->
								</template>

								<!-- 已结束但无录播 -->
								<template v-else>
									<p class="copyright-tip">因版权原因，不设直播录播</p>
								</template>


								<!-- 保留 wiki-info 区块 -->
								<div class="wiki-info"
									v-if="val.wiki_article_info && val.wiki_article_info.id && isWxBtn">

									<img src="@/assets/images/Meeting/wiki_logo.jpeg">

									<div>
										<p style="display: flex;align-items: center;">点击阅读<img
												style="width:18px;margin: 0 4px;"
												src="@/assets/images/Meeting/icon_wechatsmall.png" alt="">Med Wik</p>
										<div class="wiki-news"
											style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;width: 100%;">
											{{ val.wiki_article_info.title }}</div>
									</div>
									<wx-open-launch-weapp class="launch-btn" username="gh_4931ece2a2ce"
										appid="wxaa0bdd5050768d0e"
										:path="'pages/pagesA/newsDetail/newsDetail?id=' + val.wiki_article_info.id">
										<script type="text/wxtag-template">
											<style>.mini-btn {
											width:100%;
											height: 100%;
											position:absolute;
											opacity: 0}</style> 
											<p class="mini-btn"></p>
          								</script>
									</wx-open-launch-weapp>

								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>

		<van-popup v-model="showQrcode" round>
			<div style="margin-top:10px;">
				<h2>我们将通过服务号提醒您观看直播</h2>
				<img src="@/assets/images/cec2022/qrcode.jpg" style="width:100px;">
				<h2 class="yellowbd">STEP1.请长按二维码关注服务号</h2>
			</div>
			<h2 class="yellowbd" style="margin-bottom:10px;">STEP2.点击订阅按钮设置会议提醒</h2>
		</van-popup>
		<van-popup v-model="showChooseTime" round>
			<div style="margin-top:20px;">
				<h2>请选择在本场会议正式开始前</h2>
				<van-field readonly clickable name="picker" :value="pre_time" placeholder="点击选择时间"
					right-icon="arrow-down" @click="showPicker = true"
					style="width:100px;display: inline-block;vertical-align: bottom;border: 1px solid #DCDFE6;border-radius:5px;" />
				<span style="font-size:20px;line-height:46px;">分钟</span>
				<h2 style="margin-top:10px;">通过服务号消息提醒您观看直播</h2>
				<button @click.stop="submitSubscribe">确定</button>
			</div>

		</van-popup>
		<van-popup v-model="showPicker" position="bottom" :style="{ height: '300px' }">
			<van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false"
				title="请选择时间" />
		</van-popup>


	</div>
</template>
<script>
import { Toast } from 'vant'
import { isSubscribe, previewLive, cancelPreviewLive, WxShare, wantLookLive, RecordPlayUrl, getCharpterAISummary } from "../../../../config/interface.js";
import smoothscroll from 'smoothscroll-polyfill';
import wx from 'weixin-js-sdk'
export default {
	props: {
		meetingSchedule: {
			type: [Object, Array],
			default: () => ({})
		},
		color: {
			type: String,
			default: ''
		},
		meetingInfo: {
			type: Object,
			default: () => ({ extra_data: {} })
		},
		isWxBtn: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		safeMeetingInfo() {
			const info = this.meetingInfo || {}
			return {
				...info,
				extra_data: info.extra_data || {}
			}
		}
	},
	data() {
		return {
			isempty: false,
			meeting_id: 0,
			scheduleData: this.meetingSchedule,       //日程
			scheduleDate: Object.keys(this.meetingSchedule),   //日期
			scheduleList: [],       //日期对应的日程列表
			active: 0,
			scrollTop: 0,           //滚动距离
			selectedRecorded: this.$store.state.selectedRecorded,
			path: '',
			live_url: this.$store.state.videoUrl,
			currentRecordid: this.$store.state.videoUrl,
			is_subscribe: 0,
			showQrcode: false,
			showChooseTime: false,
			showPicker: false,
			showAISummary: true,
			chapterAISummaryInfo: {},
			options: [
				{
					value: 5,
					label: '5分钟'
				},
				{
					value: 15,
					label: '15分钟'
				},
				{
					value: 30,
					label: '30分钟'
				}
			],
			columns: [5, 15, 30],
			pre_time: 5,
			subscribe_item: {},
			subscribe_type: 0,
			time_id: null,
			time_id2: null,
			timer: null,
			showWantLookTip: false,
			currentSchedule: [],
			nowTick: Date.now(), // 驱动日程直播样式按时间刷新
			_liveScrollDone: false,
			_liveScrollRetryTimer: null,
			// 从日程列表进入时带入的 detail_id，优先滚到该具体日程
			_preferDetailId: null,
			_targetScrollDone: false,
			_targetScrollStarted: false,
			// isWxBtn: false,
		}
	},
	watch: {
		//监测meetingSchedule
		meetingSchedule(newData, oldData) {
			this.scheduleData = newData;
			this.isempty = !Object.keys(newData).length;
			this.scheduleDate = Object.keys(newData);
			this.switchDate(this.scheduleDate[0]);

		},
		'$store.state.videoUrl'(newData) {
			this.currentRecordid = newData
		},
		"time_id"(newData) {
			if (!newData) {
				this._liveScrollDone = false;
				return;
			}
			// 从日程列表带入 detail_id 时，不跟直播自动滚动抢位置
			if (this._preferDetailId) {
				return;
			}
			this._liveScrollDone = false;
			this.scrollToLiveChapter(newData);
		}

	},
	// created() {
	// 	this.checkIOSAndReload()
	// },
	mounted() {
		smoothscroll.polyfill();
		// window.addEventListener('scroll', this.handleScroll);
		let url = this.$route.query.video_url ? this.$route.query.video_url : '';
		this.path = this.$route.path;
		this.meeting_id = this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id;
		this._preferDetailId = this.$route.query.detail_id || null;
		this._targetScrollDone = false;
		this._targetScrollStarted = false;
		this.getSubscribeState();
		if (this.scheduleDate && this.scheduleDate.length) {
			this.switchDate(this.scheduleDate[0]);
		} else {
			this.startScheduleClock();
		}
	},

	beforeDestroy() {
		if (this.timer) {
			clearInterval(this.timer)
			this.timer = null
		}
		if (this._liveScrollRetryTimer) {
			clearTimeout(this._liveScrollRetryTimer)
		}
	},
	// 局部忽略元素
	ignoreElements: ['wx-open-subscribe'],
	methods: {
		getScrollParent(el) {
			let parent = el && el.parentElement;
			while (parent && parent !== document.body && parent !== document.documentElement) {
				const style = window.getComputedStyle(parent);
				const overflowY = style.overflowY;
				const canScroll =
					(overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
					parent.scrollHeight > parent.clientHeight + 1;
				if (canScroll) {
					return parent;
				}
				parent = parent.parentElement;
			}
			return null;
		},
		getStickyScrollOffset(scrollParent) {
			const tabsWrap = document.querySelector('.meeting-live1 .van-tabs__wrap');
			const tabsH = tabsWrap ? tabsWrap.offsetHeight : 0;
			const pad = 12;

			// 滚动容器在 tab pane / container 内部时，只需避开 tab 标题栏
			if (scrollParent && (
				scrollParent.classList.contains('van-tab__pane') ||
				scrollParent.classList.contains('van-tab__pane-wrapper') ||
				scrollParent.classList.contains('container')
			)) {
				return tabsH + pad;
			}

			// 页面级滚动：避开吸顶的会场条 + 视频 + tabs
			let offset = 0;
			const stickyFixed = document.querySelector('.meeting-live1 .van-sticky--fixed');
			if (stickyFixed) {
				offset = stickyFixed.getBoundingClientRect().bottom;
			} else {
				const video = document.getElementById('video');
				const top = document.getElementById('top');
				if (video) offset += video.offsetHeight;
				if (top) offset += top.offsetHeight;
			}
			offset += tabsH;
			return offset + pad;
		},
		setScrollTop(target, top, smooth = true) {
			const y = Math.max(0, top);
			if (!target) return;

			const getCurrent = () => {
				if (target === window) {
					return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
				}
				return target.scrollTop || 0;
			};

			if (!smooth) {
				if (target === window) {
					window.scrollTo(0, y);
					document.documentElement.scrollTop = y;
					document.body.scrollTop = y;
				} else {
					target.scrollTop = y;
				}
				return;
			}

			// 用自定义缓动：各机型节奏一致，也避免 behavior:smooth 兼容差导致瞬间跳转
			const start = getCurrent();
			const distance = y - start;
			if (Math.abs(distance) < 2) return;

			const duration = Math.min(1000, Math.max(500, Math.abs(distance) * 0.7));
			const startTime = performance.now ? performance.now() : Date.now();
			const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

			const step = (now) => {
				const elapsed = (now || (performance.now ? performance.now() : Date.now())) - startTime;
				const progress = Math.min(1, elapsed / duration);
				const next = start + distance * easeOutCubic(progress);
				if (target === window) {
					window.scrollTo(0, next);
					document.documentElement.scrollTop = next;
					document.body.scrollTop = next;
				} else {
					target.scrollTop = next;
				}
				if (progress < 1) {
					requestAnimationFrame(step);
				}
			};
			requestAnimationFrame(step);
		},
		scrollElementIntoView(el, smooth = true) {
			if (!el) return false;
			const scrollParent = this.getScrollParent(el);
			const offset = this.getStickyScrollOffset(scrollParent);

			if (scrollParent) {
				const parentRect = scrollParent.getBoundingClientRect();
				const elRect = el.getBoundingClientRect();
				const top = elRect.top - parentRect.top + scrollParent.scrollTop - offset;
				this.setScrollTop(scrollParent, top, smooth);
			} else {
				const pageY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
				const top = el.getBoundingClientRect().top + pageY - offset;
				this.setScrollTop(window, top, smooth);
			}
			return true;
		},
		scrollToLiveChapter(id, retryLeft = 8, onDone) {
			if (!id) return;
			if (this._liveScrollRetryTimer) {
				clearTimeout(this._liveScrollRetryTimer);
				this._liveScrollRetryTimer = null;
			}
			const tryScroll = () => {
				this.$nextTick(() => {
					const el = document.getElementById(id);
					const rect = el && el.getBoundingClientRect();
					// 已挂载且已布局完成再滚；避免个别机型 DOM 已在但尺寸为 0
					if (el && rect && (rect.width > 0 || rect.height > 0)) {
						const ok = this.scrollElementIntoView(el, true);
						if (ok) {
							this._liveScrollDone = true;
							if (typeof onDone === 'function') onDone();
							return;
						}
					}
					if (retryLeft > 0) {
						this._liveScrollRetryTimer = setTimeout(() => {
							this.scrollToLiveChapter(id, retryLeft - 1, onDone);
						}, 250);
					}
				});
			};
			// 首屏等待 tab/日程渲染
			this._liveScrollRetryTimer = setTimeout(tryScroll, retryLeft === 8 ? 300 : 0);
		},
		// 从日程列表进入：按 detail_id 滚到点击的那条具体日程（不要求直播中）
		scrollToPreferredChapter() {
			if (!this._preferDetailId || this._targetScrollDone) return false;
			if (this._targetScrollStarted) return true;
			const preferId = this._preferDetailId;
			const sessions = this.currentSchedule || [];
			// 日程数据尚未就绪，稍后再试，不要清空
			if (!sessions.length) return false;

			let matched = false;
			for (let s = 0; s < sessions.length; s++) {
				const details = sessions[s] && sessions[s].details;
				if (!details || !details.length) continue;
				for (let i = 0; i < details.length; i++) {
					if (String(details[i].id) === String(preferId)) {
						matched = true;
						break;
					}
				}
				if (matched) break;
			}

			if (!matched) {
				this._preferDetailId = null;
				return false;
			}

			this._targetScrollStarted = true;
			this.scrollToLiveChapter('chapter_' + preferId, 8, () => {
				this._targetScrollDone = true;
			});
			return true;
		},

		// 判断是否是 iOS 设备并刷新页面
		checkIOSAndReload() {
			const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
			if (isIOS && !sessionStorage.getItem('isReloaded')) {
				sessionStorage.setItem('isReloaded', 'true');
				// window.location.reload();
				this.$nextTick(() => {
					this.getWxConfig()
				})
			}
		},		//切换日期
		switchDate(date) {
			if (!date) {
				return;
			}
			this.active = date;
			this._liveScrollDone = false;
			this.scheduleList = (this.scheduleData && this.scheduleData[date]) || {};
			const keys = Object.keys(this.scheduleList);
			if (!keys.length) {
				this.currentSchedule = [];
				this.startScheduleClock();
				return;
			}
			let key = keys[0];
			let scheduleList = this.scheduleList[key] || [];

			for (var i = 0; i < scheduleList.length; i++) {
				let data = scheduleList[i]
				if (!data || !data.start_at || !data.end_at) continue;
				let startParts = String(data.start_at).split(' ');
				let endParts = String(data.end_at).split(' ');
				if (startParts[1]) {
					let startTime = startParts[1].split(':');
					data.start_at_s = startTime[0] + ':' + startTime[1];
				}
				if (endParts[1]) {
					let endTime = endParts[1].split(':');
					data.end_at_s = endTime[0] + ':' + endTime[1];
				}
			}
			this.currentSchedule = scheduleList;
			this.$store.dispatch('receiveRecording', this.scheduleList)
			this.startScheduleClock();
		},
		startScheduleClock() {
			this.tickScheduleStatus();
			if (this.timer) {
				clearInterval(this.timer);
			}
			// 定时刷新，使卡片样式 / 直播中标识随时间切换
			this.timer = setInterval(() => {
				this.tickScheduleStatus();
			}, 5000);
		},
		tickScheduleStatus() {
			this.nowTick = Date.now();
			this.syncLiveChapter();
		},
		// 根据当前时间同步「直播中」日程，并在切换时滚动定位
		syncLiveChapter() {
			// 从日程列表进入：优先滚到指定具体日程
			if (this._preferDetailId && !this._targetScrollDone) {
				if (this.scrollToPreferredChapter()) {
					// 仍同步直播态样式，但不触发直播滚动
					this.updateLiveTimeId(false);
					return;
				}
			}

			this.updateLiveTimeId(true);
		},
		// 更新直播中 time_id；allowScroll 为 false 时只更新样式不滚动
		updateLiveTimeId(allowScroll = true) {
			let liveId = null;
			const sessions = this.currentSchedule || [];
			for (let s = 0; s < sessions.length; s++) {
				const details = sessions[s] && sessions[s].details;
				if (!details || !details.length) continue;
				for (let i = 0; i < details.length; i++) {
					const item = details[i];
					if (this.isWithinTimeRange(item.start_at, item.end_at) === 2) {
						liveId = 'chapter_' + item.id;
						break;
					}
				}
				if (liveId) break;
			}
			// 带 detail_id 进入且已优先定位时，只更新样式
			if (!allowScroll || this._preferDetailId) {
				if (liveId !== this.time_id) {
					this.time_id = liveId;
				}
				return;
			}
			if (liveId !== this.time_id) {
				this.time_id = liveId;
			} else if (liveId && !this._liveScrollDone) {
				this.scrollToLiveChapter(liveId);
			}
		},
		refreshScheduleChapter() {

		},
		initChapterTimeRang(data, key) {
			// 保留方法名兼容，逻辑已统一到 syncLiveChapter
			this.syncLiveChapter();
		},
		//打开medwiki小程序文章页
		getWxConfig() {
			let that = this
			if (common.is_weixin()) {
				const url = WxShare;
				let params = {
					"jssdk": ["wx-open-launch-weapp"],
					"url": location.href
				};
				const method = 'POST';
				fetch(url, params, method)
					.then((res) => {
						if (res.code == 0) {
							wx.config({
								debug: false, // 验证结果弹窗控制，微信环境可能会因为接口安全问题出现失败弹窗，所以直接设置的false，
								appId: res.data.appId, // 公众号唯一appid
								nonceStr: res.data.nonceStr,
								timestamp: res.data.timestamp,
								signature: res.data.signature,
								jsApiList: res.data.jsApiList,//随便填写的一个
								openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app']
							})
							wx.ready(function (success) {
								that.isWxBtn = true //表示验证成功
								console.log('success', success)
							})
							wx.error(function (err) {
								Toast.fail('暂不支持', err);
								// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
								console.log('error', err)
							})


						}
					})

			}
		},
		//判断是否在当前时间段内 1未开始 2进行中 3已结束
		isWithinTimeRange(startTime, endTime) {
			if (!startTime || !endTime) return 0;
			// 读取 nowTick，使模板在定时刷新时重新计算样式（直播中/未开始/已结束）
			const now = new Date(this.nowTick || Date.now());
			let startDate = new Date(startTime.split(' ')[0])
			let endDate = new Date(endTime.split(' ')[0]);

			var [startHour, startMinute] = startTime.split(' ')[1].split(':');
			var [endHour, endMinute] = endTime.split(' ')[1].split(':');

			startDate.setHours(startHour, startMinute, 0, 0);
			endDate.setHours(endHour, endMinute, 0, 0);
			if (now < startDate) {
				return 1
			} else if (now >= startDate && now < endDate) {
				return 2
			}
			return 3
		},

		isTimeBetween(start, end, now) {
			// 如果未提供 now，则使用当前时间
			now = now || new Date();

			// 创建开始和结束时间的日期对象
			var startTime = new Date(start).setSeconds(0, 0); // 清零秒和毫秒
			var endTime = new Date(end).setSeconds(0, 0); // 清零秒和毫秒
			var nowTime = now.setSeconds(0, 0); // 清零秒和毫秒
			// console.log(startTime, endTime, nowTime)
			// 判断 nowTime 是否在 startTime 和 endTime 之间
			return nowTime >= startTime && nowTime <= endTime;
		},
		formatDetailTime(date) {
			if (!date) return ''
			const timePart = date.split(' ')[1]
			return timePart ? timePart.substring(0, 5) : date
		},
		//浏览器滚动
		handleScroll() {
			this.scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
				document.body.scrollTop;
			if (this.scrollTop > 60) {
				// console.log(1212)
			}
		},
		//播放录播
		playRecorded(suffix, index, id, value) {
			console.log(this.safeMeetingInfo)
			if (this.safeMeetingInfo.lookback_pay_status == 1 && this.safeMeetingInfo.user_pay_status == 0) {
				this.$emit('showChargePopup')
				return;
			}
			if (value.recordid) {
				this.$store.dispatch('receiveVideoUrl', value.recordid);
				//判断当前的路由
				let path = this.$route.path;
				if (path == '/meeting/schedule') {
					this.$router.push({
						path: '/meeting/live',
						query: {
							meeting_id: this.$route.query.id,
							id: id,
							video_url: value.recordid
						}
					})

				}
			} else {
				common.toast('暂无录播', 1000)
			}
			this.RecordPlayData(value.id)
			this.$emit('refreshVideoZimu', value.id)

		},
		//点击会议录播视频播放记录
		RecordPlayData(id) {
			const url = RecordPlayUrl;
			let params = {
				type_name: 'meeting_recorded_video_play',
				id: id
			};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						console.log('数据更新成功')

					}
				})
		},
		//直播
		playLive() {
			this.$store.dispatch('receiveVideoUrl', '');
			this.$emit('getLiveInfo')
			// this.$store.dispatch('receiveVideoUrl', this.live_url);

		},

		handleSubscribe(id) {
			this.scheduleList = this.scheduleData[this.active];
			let key = Object.keys(this.scheduleList)[0];
			console.log('scheduleList', this.scheduleList, key)
			let scheduleList = this.scheduleList[key];
			for (var l = 0; l < scheduleList.length; l++) {
				for (let i = 0; i < scheduleList[l].details.length; i++) {
					if (scheduleList[l].details[i].id == id) {
						this.scheduleList[key][l]['details'][i]['is_preview'] = 1;
						// this.scheduleList[key][l]['details'][i]['preview_count']++;
						console.log(scheduleList[l].details[i].id)
					}
				}
			}
		},
		getScheduleCardClass(val) {
			const status = this.isWithinTimeRange(val.start_at, val.end_at)
			return {
				nostart: status === 1,
				playing: status === 2,
				recorded: status === 3 && val.recordid && this.safeMeetingInfo.lookback_status,
				norecord: status === 3 && (!val.recordid || !this.safeMeetingInfo.lookback_status),
				change: this.currentRecordid && val.recordid === this.currentRecordid,
			}
		},
		getSubscribeState() {
			const url = isSubscribe;
			let params = {};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						this.is_subscribe = res.data.subscribe
					}
				})
		},
		//想看
		wantLook(item) {
			const url = wantLookLive;
			let params = {
				meeting_id: this.$route.query.meeting_id,
				type: 1,
				id: item.id
			};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						if (item.is_want_look == 1) {
							item.is_want_look = 0
							// item.want_look_count--
							// console.log('想看', item.is_want_look)


						} else {
							item.is_want_look = 1
							// item.want_look_count++
							// console.log('想看', item.is_want_look)
							this.$emit('showWantLook')

						}
						// Toast('您想看的内容后续会在Med Wiki发布! 敬请关注~')

					}
				})
		},
		// subscribe(item, type) {
		// item.is_preview = 1;

		// this.subscribe_item = item;
		// this.subscribe_type = type
		// if (this.is_subscribe == 1) {
		// 	// this.showChooseTime = true;
		// 	// this.$emit('subscribeTime', 1)
		// }
		// else {
		// 	Toast.loading({
		// 		duration: 0,
		// 		forbidClick: true,
		// 		message: '',
		// 	});
		// 	const url = isSubscribe;
		// 	let params = {};
		// 	const method = 'POST';
		// 	fetch(url, params, method)
		// 		.then((res) => {
		// 			Toast.clear();
		// 			if (res.code == 0) {
		// 				if (res.data.subscribe == 0) {
		// 					this.showQrcode = true
		// 				}
		// 				else {
		// 					this.is_subscribe = res.data.subscribe
		// 					// this.showChooseTime = true;
		// 					// this.$emit('subscribeTime', 1)



		// 				}
		// 			}
		// 		})
		// }

		// },
		subscribeSuccess(e) {
			// 直接打印e.detail就可以看到返回的信息了
			let subs = e.detail.subscribeDetails
			console.log(e)
			let subsStr = JSON.stringify(subs)
			if (subsStr.indexOf('accept') !== -1) {
				console.log('用户点击了允许，调用订阅接口')
				// 提取自定义属性
				const target = e.target;
				const id = target.dataset.id;
				const type = target.dataset.type;

				this.submitSubscribe({ id: id }, type);
				console.log(id, type, preview)
			} else if (subsStr.indexOf('reject') !== -1) {
				console.log('用户点击了取消')
			}

		},
		submitSubscribe(val, type) {
			this.subscribe_item = val
			this.subscribe_type = type
			Toast.loading({
				duration: 0,
				forbidClick: true,
				message: '',
			});
			const url = previewLive;
			let params = {
				meeting_id: this.meeting_id,
				type: type,
				time: this.pre_time,
				id: val.id

			};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					Toast.clear();
					if (res.code == 0) {
						common.toast('订阅成功', 1000)
						this.handleSubscribe(val.id)
					}
					else {
						common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => { })
					}
				})
		},
		subscribeFail(e) {
			console.log('订阅失败')
		},
		cancelSubscribe(val, type) {
			Toast.loading({
				duration: 0,
				forbidClick: true,
				message: '',
			});
			const url = cancelPreviewLive;
			let params = {
				meeting_id: this.meeting_id,
				type: type,
				id: val.id
			};
			const method = 'POST';
			fetch(url, params, method)
				.then((res) => {
					Toast.clear();
					if (res.code == 0) {
						val.is_preview = 0;
						// val.preview_count--
						common.toast('取消订阅成功', 1000)

					}
				})
		},
		onConfirm(val) {
			this.pre_time = val;
			this.showPicker = false
		},
		// 打开AI摘要
		openAISummary(val) {
			this.info = {}
			// this.showAISummary = true
			this.info.name = val.name
			this.info.writers = val.writers
			const url = getCharpterAISummary;
			let params = {
				id: val.id
			};
			const method = 'GET';
			fetch(url, params, method)
				.then((res) => {
					if (res.code == 0) {
						if (res.data && res.data.summarization) {
							this.info.summarization = res.data.summarization
						}
						if (res.data && res.data.keywords) {
							this.info.keywords = res.data.keywords
						}
						this.$emit('showChargeAISummary', this.info)
					}
				})
		}
	},
	destoryed() {
		clearInterval(this.timer)

	}

}
</script>
<style lang="scss" scoped>
a {
	color: #090909;
}

.live-schedule1 {
	.timeTabs-wrap {
		overflow: hidden;
		width: 100%;
		background: #fff;

	}

	.fixed {
		position: fixed;
		top: 0px;
		z-index: 1000;
	}

	.timeTabs {
		padding: 0 12px;
		height: 60px;
		@include flex(row);
		align-items: center;
		overflow: auto;
		width: 100%;
		border-bottom: 1px solid #bfbfbf;

		.tab-item {
			font-size: 14px;
			color: #666;
			width: 70px;
			height: 30px;
			text-align: center;
			line-height: 30px;
			border: 1px solid #666;
			border-radius: 2px;
			margin-right: 15px;
		}

		.active {
			color: #fff;
			background: $color-main;
			border: 0px;
		}
	}

	.content {
		padding: 0px 12px;
		// overflow-y: scroll;
		height: 100%;

		.scheduleHead {
			.name-time {
				display: flex;

				.left-flex {
					width: 60%;

					.time2 {
						line-height: 22px;
						font-size: 12px;
						background: #FFE6E7;
						display: block;
						width: 110px;
						border-radius: 20px;
						text-align: center;
						color: #901D22;
						font-weight: 500;

					}
				}

				.right-flex {
					width: 40%;
				}
			}
		}

		h3 {
			margin-top: 13px;
			font-size: 15px;
			color: #090909;
			letter-spacing: 0.53px;
			line-height: 28px;
			font-weight: normal;

			img {
				float: right;
				height: 20px;
			}
		}

		.logo {
			margin: 10px 0;

			img {
				max-width: 100%;
			}
		}



		.attendee {
			margin: 10px 0;

			.expert {
				background-color: #fff;
				border-radius: 5px;
				padding: 10px 15px;
				margin-bottom: 20px;

				.host_t {
					color: #901D22;
					font-weight: 500;
				}

				img {
					width: 18px;
				}

				span {
					line-height: 22px;
					font-size: 12px;

				}



				p {
					flex: 1;
					text-align: justify;
					font-size: 12px;
					line-height: 22px;

				}

				.text-top {
					vertical-align: top;
					margin: 0 5px 0 2px;
				}
			}
		}

		// 旧版日程列表样式（.time-item）已废弃，样式见文件底部 .chapters .schedule-card
		// .chapters {
		// 	background-color: #fff;
		// 	border-radius: 5px;
		// 	scroll-behavior: smooth;
		// 	-webkit-overflow-scrolling: touch;
		// }

		// .time-item-top {
		// 	padding: 15px 10px;
		// 	@include flex(row);
		// 	justify-content: space-between;
		// 	position: relative;
		// 	scroll-margin-top: 340px;
		// 	-webkit-scroll-margin-top: 340px;
		// 	scroll-behavior: smooth;
		// }

		// .time {
		// 	width: 40px;
		// 	line-height: 18px;
		// 	border-radius: 3px;
		// 	color: #fff;
		// 	font-weight: 500;
		// 	background: linear-gradient(90deg, #B7B7B7 0%, #929292 100%);
		// 	text-align: center;
		// 	height: 18px;

		// 	i {
		// 		font-size: 15px;
		// 		margin-right: 5px;
		// 	}
		// }

		// .introduction {
		// 	flex: 1;
		// 	letter-spacing: .46px;
		// 	margin-left: 15px;
		// 	width: calc(100% - 190px);

		// 	.title {
		// 		color: $color-black;
		// 		font-size: 13px;
		// 		margin-bottom: 10px;
		// 		text-align: justify;
		// 		flex: 1;
		// 		word-break: break-all;
		// 	}

		// 	.dot {
		// 		width: 5px;
		// 		height: 5px;
		// 		background-color: #BFBFBF;
		// 		border-radius: 10px;
		// 		margin-right: 5px;
		// 		display: inline-block;
		// 	}

		// 	.name {
		// 		font-size: 12px;
		// 		color: #666;
		// 		display: flex;
		// 		align-items: center;
		// 		padding: 5px 0;
		// 	}

		// 	.des {
		// 		font-size: 13px;
		// 		word-break: break-all;
		// 		text-align: justify;
		// 	}

		// 	span {
		// 		margin-right: 2px;
		// 	}
		// }

		// .status {
		// 	>div {
		// 		width: 100%;
		// 		display: flex;
		// 		justify-content: space-between;
		// 		align-items: center;
		// 	}
		// }

		// .icon_wrap {
		// 	width: 66px;
		// 	text-align: center;
		// 	align-self: flex-end;
		// 	height: 22px;

		// 	img {
		// 		width: 100%;
		// 	}
		// }

		// .summary {
		// 	width: 65px;
		// 	height: 22px;
		// 	text-align: center;
		// 	line-height: 22px;
		// 	background: #FFE6E7;
		// 	color: #901D22;
		// 	border-radius: 11px;
		// 	margin-right: 10px;
		// 	font-size: 13px;
		// }


		// .wiki-info {
		// 	width: calc(100% - 30px);
		// 	display: flex;
		// 	margin: 0 auto;
		// 	padding: 15px 0px;
		// 	align-items: center;
		// 	position: relative;

		// 	&>img {
		// 		width: 34px;
		// 		margin-right: 20px;
		// 	}

		// 	&>div {
		// 		flex: 1;
		// 		overflow: hidden;
		// 		color: #204EA1;
		// 		font-weight: 500;
		// 		font-size: 14px;
		// 	}
		// }



		// .time-item:not(:last-child) {
		// 	border-bottom: 1px solid #bfbfbf;
		// }

		// /*录播状态*/
		// .norecord {
		// 	.introduction .title {
		// 		color: #666;
		// 	}

		// 	.introduction p {
		// 		color: #666;
		// 	}
		// }

		// /*没有开始状态*/
		// .nostart {
		// 	.introduction .title {
		// 		color: #666;
		// 	}

		// 	.introduction p {
		// 		color: #666;
		// 	}
		// }

		// .change {
		// 	.introduction .title {
		// 		color: #204EA1;
		// 	}

		// 	.introduction p {
		// 		color: #204EA1;
		// 	}
		// }

		// /*录播状态*/
		// .recorded {
		// 	.time {
		// 		background: linear-gradient(90deg, #4C82E3 0%, #204EA1 100%);
		// 	}

		// 	.introduction {
		// 		color: #204EA1;

		// 		span {
		// 			font-size: 11px;
		// 		}
		// 	}
		// }

		// /*正在直播状态*/
		// .playing {
		// 	background-color: #FFF0F0;

		// 	.time {
		// 		background: linear-gradient(90deg, #C33E47 0%, #901D22 100%);
		// 	}

		// 	.introduction .title {
		// 		color: #000;
		// 	}

		// 	.introduction p {
		// 		color: #901D22;
		// 	}

		// 	.status {
		// 		color: #901D22;
		// 	}
		// }


	}
}

// @media screen and (min-height:1100px) {
// 	.live-schedule1 .content .time-item {
// 		scroll-margin-top: 450px !important;
// 		-webkit-scroll-margin-top: 450px !important;

// 	}
// }
.two-line {
	// white-space: nowrap;
	// overflow: hidden;
	// text-overflow: ellipsis;
	// line-clamp: 2;
	// -webkit-line-clamp: 2;
	// display: -webkit-box;
	// -webkit-box-orient: vertical;
	max-width: 100%;
	padding: 5px 0;
}

.van-popup {
	padding: 0 20px;
	text-align: center;
	color: #a21016;
	background-image: url('../../../../assets/images/cec2022/med_conference.png');
	background-size: 70% auto;
	background-position: 100% 40%;
	background-repeat: no-repeat;

	h2 {
		margin: 5px 0;
		padding: 0 10px;
		white-space: nowrap;
	}

	.yellowbd {
		border: 3px solid #ce9f70;
		border-radius: 15px;
	}

	button {
		margin: 10px 0;
		padding: 0px 40px;
		border: 3px solid #ce9f70;
		background: white;
		font-weight: 500;
		color: #a21016;
		border-radius: 20px;
		font-size: 16px;
		line-height: 36px;
	}

	/deep/.van-popup__close-icon--top-right {
		top: 0 !important;
		right: 0 !important;
	}
}


.max-page-height {
	max-height: 60vh;
}

.avatar {
	width: 24px !important;
	height: 24px !important;
	border-radius: 50%;
	object-fit: cover;
	margin-right: 4px;
	vertical-align: middle;

}

@media screen and (min-height:1100px) {
	.live-schedule1 .content .schedule-card {
		scroll-margin-top: 450px !important;
		-webkit-scroll-margin-top: 450px !important;

	}
}

.nopreview {
	color: #901D22 !important;
	border: 1px solid #901D22;
	padding: 0px 5px;
	min-width: 66px;
	height: 20px;
	line-height: 20px;
	text-align: center;
	font-size: 11px;
	border-radius: 30px;
	margin-left: 10px;
	flex-shrink: 0;
	position: relative;
}

.redbtn {
	background: #901D22;
	color: #fff !important;
	padding: 0px 5px;
	min-width: 66px;
	line-height: 22px;
	height: 22px;
	text-align: center;
	font-size: 12px;
	border-radius: 30px;
	margin-left: 10px;
	flex-shrink: 0;
}

.previewed {
	color: #fff !important;
	border: 1px solid #999;
	width: 66px;
	line-height: 22px;
	height: 22px;
	text-align: center;
	font-size: 12px;
	border-radius: 30px;
	background: #999;
	margin-left: 10px;
	flex-shrink: 0;

}

.launch-btn {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 999;
}

.chapters {
	background-color: transparent !important; // 改为透明，让卡片独立浮起
	padding: 0;
	scroll-behavior: smooth;
	-webkit-overflow-scrolling: touch;

	// ========== 新版日程卡片 ==========
	.schedule-card {
		background: #fff;
		border-radius: 12px;
		padding: 16px;
		margin-bottom: 12px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
		scroll-margin-top: 340px;
		-webkit-scroll-margin-top: 340px;

		// 头部：时间 + 浏览量
		.card-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 10px;
			gap: 10px;
			flex-wrap: wrap;
		}

		.time-tag {
			display: inline-block;
			background: #F6F7F9;
			color: #204EA1;
			padding: 4px 12px;
			border-radius: 20px;
			font-size: 12px;
			font-weight: 500;
			line-height: 18px;
			flex-shrink: 0;
		}

		.view-count {
			display: flex;
			align-items: center;
			gap: 4px;
			color: #999;
			font-size: 12px;

			img {
				width: 15px;
				height: 10px;
			}
		}

		// 标题
		.card-title {
			font-size: 14px;
			font-weight: 500;
			color: #090909;
			line-height: 20px;
			margin-bottom: 15px;
			word-break: break-all;
			// &.is-live {
			// 	text-underline-offset: 2px;
			// }
		}

		// 讲者
		.card-speaker {
			margin-bottom: 12px;

			.name {
				color: #666;
				overflow: hidden;
				font-size: 12px;
				line-height: 22px;
				text-align: left;

				.dot {
					display: none; // 新版用头像，隐藏旧圆点
				}
			}
		}

		// 封面图
		.card-cover {
			position: relative;
			width: 100%;
			border-radius: 8px;
			overflow: hidden;
			margin-bottom: 12px;
			cursor: pointer;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
			max-height: 135px;
			

			>img {
				width: 100%;
				height: auto;
				display: block;
				aspect-ratio: 16 / 9;
				object-fit: cover;
				background: #f0f0f0;
			}

			.card-cover-shadow {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.28) 100%);
				pointer-events: none;
			}

			.play-overlay {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 36px;
				color: #204EA1;
				z-index: 1;
			}
		}

		// 录播操作区
		.card-actions {
			display: flex;
			align-items: center;
			gap: 6px;
			margin-bottom: 4px;
		}

		.btn-playback {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 6px;
			height: 32px;
			border: none;
			background: #204EA1;
			color: #fff;
			border-radius: 24px;
			font-size: 13px;
			padding: 0 16px;
		}

		.btn-ai {
			flex-shrink: 0;
			height: 32px;
			line-height: 32px;
			border: none;
			background: #FFE6E7;
			color: #901D22;
			border-radius: 16px;
			padding: 0 12px;
			font-size: 13px;
		}

		// 直播中
		.card-live-status {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 4px;

		}

		.live-indicator {
			display: flex;
			align-items: center;
			gap: 6px;
			color: #901D22;
			font-size: 14px;
			font-weight: 500;

			img {
				width: 15px;
				height: 15px;
			}
		}

		.btn-live-play {
			display: flex;
			align-items: center;
			gap: 4px;
			height: 32px;
			padding: 0 16px;
			border: none;
			background: #901D22;
			color: #fff;
			border-radius: 20px;
			font-size: 13px;
		}

		// 未开始
		.card-not-started {
			display: flex;
			align-items: center;
			gap: 4px;
			color: #999;
			font-size: 13px;
			margin-top: 4px;
		}

		// 版权提示
		.copyright-tip {
			color: #999;
			font-size: 12px;
			margin-top: 8px;
			line-height: 18px;
		}

		// Wiki 区域（卡片内）
		.wiki-info {
			width: 100%;
			display: flex;
			margin-top: 12px;
			padding-top: 12px;
			align-items: center;
			position: relative;

			&>img {
				width: 34px;
				margin-right: 20px;
			}

			&>div {
				flex: 1;
				overflow: hidden;
				color: #204EA1;
				font-weight: 500;
				font-size: 14px;
			}
		}

		.card-header {
			order: 0;
		}

		.card-title {
			order: 1;
		}

		.card-cover {
			order: 2;
			margin-bottom: 10px;
		}

		.card-speaker {
			order: 3;
			margin-top: 0;
			margin-bottom: 12px;
		}

		.card-actions {
			order: 4;
		}

		.wiki-info {
			order: 5;
		}

		.card-live-status {
			order: 4;
		}

		.card-not-started {
			order: 4;
		}

		// ===== 三种状态 =====

		// 已结束 + 有录播
		&.recorded {
			display: flex;
			flex-direction: column;


		}

		// 直播中
		&.playing {
			background-color: #FFF0F0;
			.time-tag {
				background: #901D22;
				color: #FFFF;
			}

		}

		// 未开始
		&.nostart {
			.time-tag {
				background: #F6F7F9;
				color: #666;
			}
		}

		// 已结束无录播
		&.norecord {
			.card-title {
				color: #666;
			}
		}

		// 当前播放中
		&.change {
			.card-title {
				color: #204EA1;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/Schedule.vue